import { useStorage } from '@vueuse/core'
import { ref, watch } from 'vue'

import { useVuetify } from './vuetify'

const themes = ref([
  {
    text: 'Sombre',
    value: 'dark',
  },
  {
    text: 'Lumineux',
    value: 'light',
  },
])
const theme = useStorage('theme', 'light', localStorage)

export const useTheme = () => {
  const vuetify = useVuetify()
  watch(theme, () => {
    vuetify.theme.dark = theme.value === 'dark' ? true : false
  }, {
    immediate: true,
  })

  return {
    themes,
    theme,
  }
}
